/**
 * The function checks if a given argument is undefined or null.
 * @param {any} arg
 */
export const isNil = (arg: any) => arg === undefined || arg === null;
